import React, {
  memo
} from "react";
import {
  Pressable,
  StyleSheet
} from "react-native";
import {
  Card,
  Text
} from "@constants/Themed";
import {
  CountUp
} from "use-count-up";
import {
  WIDGET_CONFIGS
} from "./config";
import navigate from "../../../../rootNavigation";
import {
  useDispatch
} from "react-redux";
import {
  SHOW_NOTIFICATIONS_MODAL
} from "@reduxLocal/actions/types";
type StatCardProps = {
  widgetKey: keyof typeof WIDGET_CONFIGS;
  value: number;
};

const StatCard: React.FC < StatCardProps > = ({
  widgetKey,
  value
}) => {
  const config = WIDGET_CONFIGS[widgetKey];
  const dispatch = useDispatch();

  const handlePress = () => {
    if (widgetKey === "messages") {
      navigate("MailLoginScreen");
    }
    if (widgetKey === "calendar") {
      dispatch({
        type: SHOW_NOTIFICATIONS_MODAL
      });
    }
    if (widgetKey === "invitations") {
      navigate("Invitations");
    }
  };

  return ( <
    Card style = {
      [
        styles.statCard, {
          backgroundColor: config.backgroundColor
        },
      ]
    } >
    <
    Pressable onPress = {
      handlePress
    }
    style = {
      styles.statCardPressable
    } >
    <
    config.icon name = {
      config.name
    }
    size = {
      32
    }
    color = {
      config.color
    }
    /> <
    Text style = {
      styles.statValue
    } >
    <
    CountUp isCounting start = {
      0
    }
    end = {
      value
    }
    /> <
    /Text> <
    Text style = {
      styles.statLabel
    } > {
      config.label
    } < /Text> <
    /Pressable> <
    /Card>
  );
};

const styles = StyleSheet.create({
  statCard: {
    width: "100%",
    height: "100%",
    borderRadius: 15,
    shadowRadius: 6,
    shadowOpacity: 0.2,
    padding: 15,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  statCardPressable: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  statValue: {
    color: "white",
    fontSize: 18,
    fontWeight: "bold",
    marginTop: 6,
    marginBottom: 2,
  },
  statLabel: {
    color: "white",
    fontSize: 12,
    marginTop: 2,
  },
});

export default memo(StatCard);
